import Singleton from "./Singleton"
import { isObject } from './utils.js'



/**
 * Access local and session storage
 */
export default class Storage extends Singleton {
  _isSupported = true
  _storageType = "localStorage"

  constructor () {
    super()

    if(!Storage.test()) {
      this._isSupported = false
      //throw App.error('Storage is not supported')
    } else
      this._isSupported = true

    this._storageType = 'localStorage'
  }

  static test () {
    try {
      let a = "test"
      localStorage.setItem(a, a)
      localStorage.removeItem(a)
      return true
    } catch(e) {
      console.error(e, "Storage: localStorage is not supported")
      return false
    }
  }

  storageControls (storage) {

    return {
      get (key) {
        let res = null
        try {
          res = JSON.parse(storage.getItem(key))
        } catch (e) {
          res = storage.getItem(key)
        }
        return res
      },
      set (key, val) {
        if(typeof val === 'object')
          storage.setItem(key, JSON.stringify(val))
        else
          storage.setItem(key, JSON.stringify(val))
        return val
      },
      remove (key) {
        storage.removeItem(key)
      }
    }
  }

  setStorageType (type) {
    this._storageType = type
    return this
  }

  get session () {
    this._storageType = 'sessionStorage'
    return this.storageControls(sessionStorage)
  }

  get local () {
    return this.storageControls(localStorage)

    /*this._storageType = 'localStorage'
    return {
      get: (key) => this.get(key),
      set: (key, value) => this.set(key, value),
    }*/
  }

  get (key) {
    if(arguments.length > 1) {
      let tmp = this.storageControls(window[this._storageType]).get(key)

      for (let i = 1 ; i < arguments.length ; i++) {
        if (typeof tmp === 'object' && tmp !== null && arguments[i] in tmp) {
          tmp = tmp[arguments[i]]
        } else {
          tmp = null
          break
        }
      }

      return tmp
    }
    else
      return this.storageControls(window[this._storageType]).get(key)
  }

  set (key, ...args) {
    let data = this.storageControls(window[this._storageType]).get(key)
    if((data && typeof data === 'object') || arguments.length > 2) {
      data = (data === null) ? {} : data

      let objNew = (function newObject (...args) {
        if (args.length === 1)
          return args[0]
        else
          return {[args.shift()]: newObject(...args)}
      })(...args)

      this.mergeDeep(data, objNew)

      return this.storageControls(window[this._storageType]).set(key, data)

    } else
      return this.storageControls(window[this._storageType]).set(key, arguments[1])
  }

  remove (key) {
    window[this._storageType].getItem(key)
    // TODO: not ready. Save to erased

    return window[this._storageType].removeItem(key)
  }


  mergeDeep (target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
      for (const key in source) {
        if (isObject(source[key])) {
          if (!target[key]) Object.assign(target, { [key]: {} });
          this.mergeDeep(target[key], source[key]);
        } else {
          Object.assign(target, { [key]: source[key] });
        }
      }
    }

    return this.mergeDeep(target, ...sources);
  }
}